import PropTypes from "prop-types";
import "./BalanceCard.css";

const BalanceCard = ({ balance, currency }) => {
  return (
    <div className="balance-card">
      <div className="balance-card__icon">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.25 0C36.9375 0 37.5 0.559375 37.5 1.25C37.5 1.94062 36.9375 2.5 36.25 2.5H6.25C4.17891 2.5 2.5 4.17891 2.5 6.25V28.75C2.5 30.8203 4.17891 32.5 6.25 32.5H33.75C35.8203 32.5 37.5 30.8203 37.5 28.75V11.25C37.5 9.17969 35.8203 7.5 33.75 7.5H8.75C8.0625 7.5 7.5 6.9375 7.5 6.25C7.5 5.5625 8.0625 5 8.75 5H33.75C37.2031 5 40 7.79688 40 11.25V28.75C40 32.2031 37.2031 35 33.75 35H6.25C2.79844 35 0 32.2031 0 28.75V6.25C0 2.79844 2.79844 0 6.25 0H36.25ZM28.125 20C28.125 18.9609 28.9609 18.125 30 18.125C31.0391 18.125 31.875 18.9609 31.875 20C31.875 21.0391 31.0391 21.875 30 21.875C28.9609 21.875 28.125 21.0391 28.125 20Z"
            fill="#FF5A37"
          />
        </svg>
      </div>
      <div className="balance-card__content">
        <div className="balance-card__label">Total Balance:</div>
        <div className="balance-card__amount">
          {balance} <span className="balance-card__currency">{currency}</span>
        </div>
      </div>
    </div>
  );
};

BalanceCard.propTypes = {
  balance: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
};

export default BalanceCard;

